export default {
  RECEIVE_BOOKING_ONLY: true,
};
